import Button, { ButtonProps } from '@mui/material/Button'
import { forwardRef } from 'react'
import {
  TranslatableBox,
  TranslatableBoxProps,
} from '../../../../../feature/localization/component/atom/TranslatableBox'

export type AppButtonProps = Omit<TranslatableBoxProps, 'variant'> & ButtonProps

type AppButtonRootProps = ButtonProps & {
  appButtonComponent?: ButtonProps['component']
}

const AppButtonRoot = forwardRef<HTMLButtonElement, AppButtonRootProps>((props, ref) => {
  const { appButtonComponent = 'button', ...rest } = props

  return (
    <Button
      {...rest}
      ref={ref}
      component={appButtonComponent}
    />
  )
})

AppButtonRoot.displayName = 'AppButtonRoot'

export const AppButton = forwardRef<HTMLButtonElement, AppButtonProps>((props, ref) => {
  const { component, ...rest } = props

  return (
    <TranslatableBox
      ref={ref}
      component={AppButtonRoot}
      appButtonComponent={component}
      {...rest}
    />
  )
})

AppButton.displayName = 'AppButton'
